export const environment = {
    production: true,
    type: 'dev',
    config: {
        apiBasePath: 'https://devapi.neatlyliving.com/api/v1/',
        productionResources: ''
    }
};
